<section class="cz-my-zone-help-dialog-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
            <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div class="row">
      <div class="col-xs">
        <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(message.message)"></div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-actions>
    <div class="row">
      <div class="col-xs-12 end-xs button-margin">
        <button mat-flat-button color="accent" mat-dialog-close [innerHTML]="'$btn_close' | translate"></button>
      </div>
    </div>
  </mat-actions>
</section>
